import React from 'react'
import { LinkToProductItem } from './Links/LinkToProductItem'
import { truncate } from '@ztechapps/common.utils'
import { ProductThumbImage } from '@ztechapps/product.webui'
import { HorizontalStack, TooltipPopOver } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import type { Product } from '@ztechapps/common.contract'

export const ProductCardSmall = ({
  addToCartContent,
  ...props
}: {
  addToCartContent?: React.ReactNode
} & Partial<Product>) => {
  const { coverImage, coverImageThumb, name, _id, code } = props

  return (
    <HorizontalStack gap={2} className="align-items-start">
      <div>
        <ProductThumbImage
          coverImageThumb={coverImageThumb}
          url={coverImage}
          name={name}
          className={' '}
          style={{ height: 80, width: 80 }}
        />
      </div>
      <TooltipPopOver tooltipBody={name}>
        <div className="flex-fill">
          <Stack gap={2}>
            <LinkToProductItem _id={_id} productCode={code} className="title">
              {code} - {truncate(name, 43)}
            </LinkToProductItem>
            <div>{addToCartContent}</div>
          </Stack>
        </div>
      </TooltipPopOver>
    </HorizontalStack>
  )
}

//
